const liveness = {
    cameraModule: {
        backgroundColor: { value: '{colors.background.primary.value}' },
    },
};

export { liveness };
